import { getQueueMember } from 'flow/utils/pbx-utils';
import React from 'react';
import Toggle from '../ui-components/Toggle';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { fromJS } from 'immutable';
import { updateQueueMember } from 'flow/actions/pbx-actions';
import {
    selectAllQueueMembers,
    selectQueues,
} from 'flow/selectors/queue-selectors';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import Icon from 'flow/components/ui-components/Icon';
import Tooltip from '../ui-components/Tooltip';

const Queues = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const extensionKey = useAppSelector(selectOwnExtensionKey);
    const queues = useAppSelector(selectQueues);
    const allQueueMembers = useAppSelector(selectAllQueueMembers);

    const toggle = (queue: any, queueMember: any) => {
        const queueMemberDTO = {
            key: queueMember.get('key'),
            loggedIn: !queueMember.get('loggedIn'),
        };

        dispatch(updateQueueMember(queue.get('key'), fromJS(queueMemberDTO)));
    };

    const loginableQueues = queues
        .sort((a: any, b: any) =>
            a.get('description').localeCompare(b.get('description')),
        )
        .map((queue: any) => {
            const queueMembers = allQueueMembers.get(queue.get('key'));
            const queueMember = getQueueMember(extensionKey, queueMembers);

            if (queueMember) {
                return (
                    <div
                        className="flex h-10 items-center justify-between rounded-sm p-2 hover:bg-gray-200"
                        key={queue.get('key')}
                    >
                        <p className="flex-1 truncate">
                            {queue.get('description')}
                        </p>
                        <Toggle
                            height={20}
                            width={32}
                            onChange={() => toggle(queue, queueMember)}
                            value={queueMember.get('loggedIn', false)}
                            text={queue.get('description')}
                        />
                    </div>
                );
            }

            return null;
        })
        .valueSeq()
        .filter((value: any) => value !== null);

    if (loginableQueues.isEmpty()) {
        return null;
    }

    return (
        <>
            <div className="flex items-center justify-between">
                <h3 className="px-2 text-xs font-bold">
                    {i18next.t('Profile.SegmentedControl.QueueLogin.Title')}
                </h3>
                <Tooltip
                    label={i18next.t(
                        'Profile.SegmentedControl.QueueLogin.Tooltip.Info',
                    )}
                    placement="bottom"
                >
                    <Icon iconKey="info" size="1rem" />
                </Tooltip>
            </div>

            {loginableQueues}
        </>
    );
};

export default Queues;
